import { useCallback, useEffect, useMemo, useState } from 'react';
import { getNovaPoshtaDepartments, selectAutoCompleteNovaPoshtas } from '../feature';
import { useAppDispatch, useAppState } from '@/store';
import debounce from 'lodash.debounce';

export const useAutocompleteNovaPoshtaDepartments = (orderId: string) => {
  const [isLoading, setIsLoading] = useState(false);
  const departments = useAppState(selectAutoCompleteNovaPoshtas);
  const dispatch = useAppDispatch();

  const handleSearch = useCallback(
    debounce(async (search: string, settlementFrom_id: string, settlementTo_id: string) => {
      if (!settlementFrom_id || !settlementTo_id || settlementTo_id === 'undefined') {
        return;
      }

      try {
        setIsLoading(true);
        await dispatch(
          getNovaPoshtaDepartments({
            name: search,
            order: orderId,
            settlementFrom_id,
            settlementTo_id,
          }),
        );
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    }, 500),
    [orderId],
  );

  useEffect(() => {
    return () => {
      handleSearch.cancel();
    };
  }, [handleSearch]);

  return useMemo(
    () => ({
      departments: departments ?? [],
      departmentsOptions: departments?.map((item) => ({
        label: item.name ?? '',
        value: item.id,
      })),
      isLoading,
      onSearch: handleSearch,
    }),
    [departments, isLoading, handleSearch],
  );
};
